import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Button from "../button";
import { Link } from "react-router-dom";
import axios from "../../API/axios";
// import { Dropdown } from "reactstrap";
import MoreHorizSharpIcon from '@mui/icons-material/MoreHorizSharp';
import { Dropdown } from "react-bootstrap";
import { Menu, MenuItem } from "@mui/material";
import CompanyImg from '../../assets/images/khoj-images/image 484.png'
import CompanyInteraction from "../../khojpages/FollowedCompanies/CompanyInteraction"; 


 
function Employer() {


  const token = localStorage.getItem('token')

  // ...............................All company List.......................................
  const [isLoading, setIsLoading] = useState(true);
  const [companyList, setCompanyList] = useState([]); 

  const getCompanyList = (page = 1) => {
    const data = { 
      pageNumber: page,
      pageSize: 10, 
    };

    axios
      .post(`/Company/GetAll?CompType=Company`, data) 
      .then((response) => {
        const res = response.data.responseData.companyList;
        console.log("company list====>",response.data.responseData.companyList);
         
        setCompanyList(res)
        setIsLoading(false);
        
      })
      .catch((error) => {
        console.log("error",error) 
      });
  };

  useEffect(() => { 
    getCompanyList(); // Initial fetch on mount
  }, []);

  // ...............................All company List.......................................

  
  return (
    <section className="company">
      <div className="container">
        <div className="wd-employer">
          <div className="tf-title">
            <div className="group-title">
              <h1>Top Companies</h1>
              <p>Showing companies based on reviews and recent job openings</p>
            </div>
            <Button title="All Companies" link="/companies" />
          </div>
          <div className="row wow fadeInUp ">
            {companyList.slice(0,4).map((data) => (
              <div key={data.id} className="col-xl-3 col-lg-4 col-md-6 col-sm-6">
                <div className="employer-block">
                   <div className="button-readmore d-flex justify-content-end align-item-center"> 
                         
                      {token === null ? "" : <CompanyInteraction Compuid={data.uid} />  } 

                     </div>
                  <div className="inner-box">
                    <div className="logo-company">
                      <img src={data.logoImage} alt="Jobtex" />
                    </div>
                    <div className="box-content"> 
                      <h3>
                      {token === null ? data.name : <Link to={`/Companydetails/${data.uid}`} >{data.name}</Link>} 
                          
                      </h3>
                      
                       <p className="info">
                           {data.map === null ? '' : <>
                           <span className="icon-map-pin"></span>{data.map}</>
                           }
                       </p>
                    </div>
                    
                  </div> 
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Employer;
